import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layout
import Layout from './components/Layout/Layout';

// Auth Components
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import VerifyEmail from './components/Auth/VerifyEmail';
import VerifyOtp from './components/Auth/VerifyOtp';
import ProtectedRoute from './components/Auth/ProtectedRoute';
// import Unauthorized from './components/Auth/Unauthorized';

// Main Components
import Dashboard from './components/Main/Dashboard';
import Members from './components/Main/Members';
import Broadcast from './components/Main/Broadcast';
import Automation from './components/Main/Automation';

// Engagement Components
import Birthdays from './components/Engagement/Birthdays';
import Polls from './components/Engagement/Polls';
import Inbox from './components/Engagement/Inbox';
import Attendance from './components/Engagement/Attendance';
import Events from './components/Engagement/Events';
import PrayerWall from './components/Engagement/PrayerWall';
import Devotionals from './components/Engagement/Devotionals';

// Growth Components
import DripCampaigns from './components/Growth/DripCampaigns';
import VisitorFollowUp from './components/Growth/VisitorFollowUp';
import GivingCampaigns from './components/Growth/GivingCampaigns';
import Chatbot from './components/Growth/Chatbot';
import MemberHealth from './components/Growth/MemberHealth';

// Data & Reports Components
import Analytics from './components/DataReports/Analytics';
import GroupsManager from './components/DataReports/GroupsManager';
import MessageLog from './components/DataReports/MessageLog';
import BulkImport from './components/DataReports/BulkImport';
import TemplatesLibrary from './components/DataReports/TemplatesLibrary';

// System Components
import Organization from './components/System/Organization';
import ShortcodeSetup from './components/System/ShortcodeSetup';
import MultiBranch from './components/System/MultiBranch';
import OptOutManager from './components/System/OptOutManager';
import Notifications from './components/System/Notifications';
import SetupOnboarding from './components/System/Onboarding';
import Billing from './components/System/Billing';
import Settings from './components/System/Settings';
import SenderIds from './components/System/SenderIds';
import SmsBalance  from './components/System/SmsBalance';
import Pricing  from './components/System/Pricing';

// Frontend Components
import Features  from './components/Frontend/Features';
import Testimonial from './components/Frontend/Testimonials';
import Stats from './components/Frontend/Stats';
import Blogs from './components/Frontend/BlogPosts';
import Regions from './components/Frontend/Regions';
import PlanPricing from './components/Frontend/PricingPlans';

// User Management Components
import User from './components/UserManagement/User';
import Role from './components/UserManagement/Role';
import Permission from './components/UserManagement/Permission';
import Profile from './components/UserManagement/Profile';

// Toast helper
import { showToast } from './utils/toastHelper';

function App() {
  return (
    <>
      <Routes>
        {/* ============================================
            PUBLIC ROUTES - No Layout
            ============================================ */}
        <Route path="/login" element={<Login showToast={showToast} />} />
        <Route path="/register" element={<Register showToast={showToast} />} />
        <Route path="/forgot-password" element={<ForgotPassword showToast={showToast} />} />
        <Route path="/reset-password" element={<ResetPassword showToast={showToast} />} />
        <Route path="/verify-email" element={<VerifyEmail showToast={showToast} />} />
        <Route path="/verify-otp" element={<VerifyOtp showToast={showToast} />} />
        {/* <Route path="/unauthorized" element={<Unauthorized />} /> */}

        {/* ============================================
            PROTECTED ROUTES - With Layout
            ============================================ */}

        {/* MAIN */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/members"
          element={
            <ProtectedRoute>
              <Layout>
                <Members showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/broadcast"
          element={
            <ProtectedRoute>
              <Layout>
                <Broadcast showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/automation"
          element={
            <ProtectedRoute>
              <Layout>
                <Automation showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* ENGAGEMENT */}
        <Route
          path="/birthdays"
          element={
            <ProtectedRoute>
              <Layout>
                <Birthdays showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/polls"
          element={
            <ProtectedRoute>
              <Layout>
                <Polls showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/inbox"
          element={
            <ProtectedRoute>
              <Layout>
                <Inbox showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/attendance"
          element={
            <ProtectedRoute>
              <Layout>
                <Attendance showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <Layout>
                <Events showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/prayers"
          element={
            <ProtectedRoute>
              <Layout>
                <PrayerWall showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/devotionals"
          element={
            <ProtectedRoute>
              <Layout>
                <Devotionals showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* GROWTH */}
        <Route
          path="/drips"
          element={
            <ProtectedRoute>
              <Layout>
                <DripCampaigns showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/visitors"
          element={
            <ProtectedRoute>
              <Layout>
                <VisitorFollowUp showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/giving"
          element={
            <ProtectedRoute>
              <Layout>
                <GivingCampaigns showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/chatbot"
          element={
            <ProtectedRoute>
              <Layout>
                <Chatbot showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/health"
          element={
            <ProtectedRoute>
              <Layout>
                <MemberHealth showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* DATA & REPORTS */}
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <Layout>
                <Analytics showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/groups"
          element={
            <ProtectedRoute>
              <Layout>
                <GroupsManager showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/msglog"
          element={
            <ProtectedRoute>
              <Layout>
                <MessageLog showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/import"
          element={
            <ProtectedRoute>
              <Layout>
                <BulkImport showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/import"
          element={
            <ProtectedRoute>
              <Layout>
                <BulkImport showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/templates"
          element={
            <ProtectedRoute>
              <Layout>
                <TemplatesLibrary showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* SYSTEM */}
        <Route
          path="/organization"
          element={
            <ProtectedRoute>
              <Layout>
                <Organization showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shortcode"
          element={
            <ProtectedRoute>
              <Layout>
                <ShortcodeSetup showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/branches"
          element={
            <ProtectedRoute>
              <Layout>
                <MultiBranch showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/optout"
          element={
            <ProtectedRoute>
              <Layout>
                <OptOutManager showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Layout>
                <Notifications showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <Layout>
                <SetupOnboarding showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <ProtectedRoute>
              <Layout>
                <Billing showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/pricing"
          element={
            <ProtectedRoute>
              <Layout>
                <Pricing showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Layout>
                <Settings showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/sender-ids"
          element={
            <ProtectedRoute>
              <Layout>
                <SenderIds showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/sms-balance"
          element={
            <ProtectedRoute>
              <Layout>
                <SmsBalance showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* USER MANAGEMENT */}
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Layout>
                <User showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/roles"
          element={
            <ProtectedRoute>
              <Layout>
                <Role showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/permissions"
          element={
            <ProtectedRoute>
            {/* <ProtectedRoute requiredPermissions={['manage_permissions']}> */}
              <Layout>
                <Permission showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout>
                <Profile showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* FRONTEND MANAGEMENT */}
        <Route
          path="/features"
          element={
            <ProtectedRoute>
              <Layout>
                <Features showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/testimonials"
          element={
            <ProtectedRoute>
              <Layout>
                <Testimonial showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/stats"
          element={
            <ProtectedRoute>
            {/* <ProtectedRoute requiredPermissions={['manage_permissions']}> */}
              <Layout>
                <Stats showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/blogs"
          element={
            <ProtectedRoute>
              <Layout>
                <Blogs showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/regions"
          element={
            <ProtectedRoute>
              <Layout>
                <Regions showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/plan-pricing"
          element={
            <ProtectedRoute>
              <Layout>
                <PlanPricing showToast={showToast} />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* REDIRECTS */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;